export default {
    path: '/inspection/inspectionMsg',
    name: 'InspectionMsg',
    component: () => import(/* webpackChunkName: "inspectionMsg" */ '../../views/inspection/components/inspectionMsg.vue')
}